import { render, staticRenderFns } from "./ValuationHistory.vue?vue&type=template&id=226b8f34&"
import script from "./ValuationHistory.vue?vue&type=script&lang=js&"
export * from "./ValuationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports